import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ContactUsResolver {
  constructor() { }
  resolve(): string { return ''; }
}